<template>
  <div>
    <template v-if="edit">
      <h4>{{ item.name }}</h4>
      <input type="text" :name="item.key" :value="info" class="uk-input" />
    </template>
    <template v-else>
      <h4>{{ item.name }}</h4>
      <p>{{ info }}</p>
    </template>
  </div>
</template>

<script>
// <template v-if="edit && preferences.editable.indexOf(item.key) >= 0">
export default {
  props: {
    info: String,
    item: Object,
    preferences: Object,
    edit: Boolean
  },
  created() {}
};
</script>

<style>
.detailItem {
  display: block;
  padding: 10px;
  margin-bottom: 5px;
}
.detailItem h4 {
  margin: 0px;
  padding: 0px;
  color: #666;
  font-size: 13px;
}
.detailItem p {
  margin: 0px;
  padding: 0px;
  font-size: 15px;
  color: #222;
}
</style>
